"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Msg = void 0;
var msgs_1 = require("./bank/msgs");
var msgs_2 = require("./distribution/msgs");
var msgs_3 = require("./feegrant/msgs");
var msgs_4 = require("./gov/msgs");
var msgs_5 = require("./market/msgs");
var msgs_6 = require("./authz/msgs");
var msgs_7 = require("./oracle/msgs");
var msgs_8 = require("./slashing/msgs");
var msgs_9 = require("./staking/msgs");
var msgs_10 = require("./wasm/msgs");
var msgs_11 = require("./ibc-transfer/msgs");
var client_1 = require("./ibc/msgs/client");
var connection_1 = require("./ibc/msgs/connection");
var channel_1 = require("./ibc/msgs/channel");
var crisis_1 = require("./crisis");
var Msg;
(function (Msg) {
    function fromAmino(data) {
        switch (data.type) {
            // bank
            case 'bank/MsgSend':
                return msgs_1.MsgSend.fromAmino(data);
            case 'bank/MsgMultiSend':
                return msgs_1.MsgMultiSend.fromAmino(data);
            // distribution
            case 'distribution/MsgModifyWithdrawAddress':
                return msgs_2.MsgSetWithdrawAddress.fromAmino(data);
            case 'distribution/MsgWithdrawDelegationReward':
                return msgs_2.MsgWithdrawDelegatorReward.fromAmino(data);
            case 'distribution/MsgWithdrawValidatorCommission':
                return msgs_2.MsgWithdrawValidatorCommission.fromAmino(data);
            case 'distribution/MsgFundCommunityPool':
                return msgs_2.MsgFundCommunityPool.fromAmino(data);
            // feegrant
            case 'feegrant/MsgGrantAllowance':
                return msgs_3.MsgGrantAllowance.fromAmino(data);
            case 'feegrant/MsgRevokeAllowance':
                return msgs_3.MsgRevokeAllowance.fromAmino(data);
            // gov
            case 'gov/MsgDeposit':
                return msgs_4.MsgDeposit.fromAmino(data);
            case 'gov/MsgSubmitProposal':
                return msgs_4.MsgSubmitProposal.fromAmino(data);
            case 'gov/MsgVote':
                return msgs_4.MsgVote.fromAmino(data);
            case 'gov/MsgVoteWeighted':
                return msgs_4.MsgVoteWeighted.fromAmino(data);
            // market
            case 'market/MsgSwap':
                return msgs_5.MsgSwap.fromAmino(data);
            case 'market/MsgSwapSend':
                return msgs_5.MsgSwapSend.fromAmino(data);
            // msgauth
            case 'msgauth/MsgGrantAuthorization':
                return msgs_6.MsgGrantAuthorization.fromAmino(data);
            case 'msgauth/MsgRevokeAuthorization':
                return msgs_6.MsgRevokeAuthorization.fromAmino(data);
            case 'msgauth/MsgExecAuthorized':
                return msgs_6.MsgExecAuthorized.fromAmino(data);
            // oracle
            case 'oracle/MsgDelegateFeedConsent':
                return msgs_7.MsgDelegateFeedConsent.fromAmino(data);
            case 'oracle/MsgAggregateExchangeRatePrevote':
                return msgs_7.MsgAggregateExchangeRatePrevote.fromAmino(data);
            case 'oracle/MsgAggregateExchangeRateVote':
                return msgs_7.MsgAggregateExchangeRateVote.fromAmino(data);
            // slashing
            case 'slashing/MsgUnjail':
                return msgs_8.MsgUnjail.fromAmino(data);
            // staking
            case 'staking/MsgDelegate':
                return msgs_9.MsgDelegate.fromAmino(data);
            case 'staking/MsgUndelegate':
                return msgs_9.MsgUndelegate.fromAmino(data);
            case 'staking/MsgBeginRedelegate':
                return msgs_9.MsgBeginRedelegate.fromAmino(data);
            case 'staking/MsgCreateValidator':
                return msgs_9.MsgCreateValidator.fromAmino(data);
            case 'staking/MsgEditValidator':
                return msgs_9.MsgEditValidator.fromAmino(data);
            // wasm
            case 'wasm/MsgStoreCode':
                return msgs_10.MsgStoreCode.fromAmino(data);
            case 'wasm/MsgMigrateCode':
                return msgs_10.MsgMigrateCode.fromAmino(data);
            case 'wasm/MsgInstantiateContract':
                return msgs_10.MsgInstantiateContract.fromAmino(data);
            case 'wasm/MsgExecuteContract':
                return msgs_10.MsgExecuteContract.fromAmino(data);
            case 'wasm/MsgMigrateContract':
                return msgs_10.MsgMigrateContract.fromAmino(data);
            case 'wasm/MsgUpdateContractAdmin':
                return msgs_10.MsgUpdateContractAdmin.fromAmino(data);
            case 'wasm/MsgClearContractAdmin':
                return msgs_10.MsgClearContractAdmin.fromAmino(data);
            // ibc-transfer
            case 'cosmos-sdk/MsgTransfer':
                return msgs_11.MsgTransfer.fromAmino(data);
            // crisis
            case 'crisis/MsgVerifyInvariant':
                return crisis_1.MsgVerifyInvariant.fromAmino(data);
        }
    }
    Msg.fromAmino = fromAmino;
    function fromData(data) {
        switch (data['@type']) {
            // bank
            case '/cosmos.bank.v1beta1.MsgSend':
                return msgs_1.MsgSend.fromData(data);
            case '/cosmos.bank.v1beta1.MsgMultiSend':
                return msgs_1.MsgMultiSend.fromData(data);
            // distribution
            case '/cosmos.distribution.v1beta1.MsgSetWithdrawAddress':
                return msgs_2.MsgSetWithdrawAddress.fromData(data);
            case '/cosmos.distribution.v1beta1.MsgWithdrawDelegatorReward':
                return msgs_2.MsgWithdrawDelegatorReward.fromData(data);
            case '/cosmos.distribution.v1beta1.MsgWithdrawValidatorCommission':
                return msgs_2.MsgWithdrawValidatorCommission.fromData(data);
            case '/cosmos.distribution.v1beta1.MsgFundCommunityPool':
                return msgs_2.MsgFundCommunityPool.fromData(data);
            // feegrant
            case '/cosmos.feegrant.v1beta1.MsgGrantAllowance':
                return msgs_3.MsgGrantAllowance.fromData(data);
            case '/cosmos.feegrant.v1beta1.MsgRevokeAllowance':
                return msgs_3.MsgRevokeAllowance.fromData(data);
            // gov
            case '/cosmos.gov.v1beta1.MsgDeposit':
                return msgs_4.MsgDeposit.fromData(data);
            case '/cosmos.gov.v1beta1.MsgSubmitProposal':
                return msgs_4.MsgSubmitProposal.fromData(data);
            case '/cosmos.gov.v1beta1.MsgVote':
                return msgs_4.MsgVote.fromData(data);
            case '/cosmos.gov.v1beta1.MsgVoteWeighted':
                return msgs_4.MsgVoteWeighted.fromData(data);
            // market
            case '/terra.market.v1beta1.MsgSwap':
                return msgs_5.MsgSwap.fromData(data);
            case '/terra.market.v1beta1.MsgSwapSend':
                return msgs_5.MsgSwapSend.fromData(data);
            // authz
            case '/cosmos.authz.v1beta1.MsgGrant':
                return msgs_6.MsgGrantAuthorization.fromData(data);
            case '/cosmos.authz.v1beta1.MsgRevoke':
                return msgs_6.MsgRevokeAuthorization.fromData(data);
            case '/cosmos.authz.v1beta1.MsgExec':
                return msgs_6.MsgExecAuthorized.fromData(data);
            // oracle
            case '/terra.oracle.v1beta1.MsgDelegateFeedConsent':
                return msgs_7.MsgDelegateFeedConsent.fromData(data);
            case '/terra.oracle.v1beta1.MsgAggregateExchangeRatePrevote':
                return msgs_7.MsgAggregateExchangeRatePrevote.fromData(data);
            case '/terra.oracle.v1beta1.MsgAggregateExchangeRateVote':
                return msgs_7.MsgAggregateExchangeRateVote.fromData(data);
            // slashing
            case '/cosmos.slashing.v1beta1.MsgUnjail':
                return msgs_8.MsgUnjail.fromData(data);
            // staking
            case '/cosmos.staking.v1beta1.MsgDelegate':
                return msgs_9.MsgDelegate.fromData(data);
            case '/cosmos.staking.v1beta1.MsgUndelegate':
                return msgs_9.MsgUndelegate.fromData(data);
            case '/cosmos.staking.v1beta1.MsgBeginRedelegate':
                return msgs_9.MsgBeginRedelegate.fromData(data);
            case '/cosmos.staking.v1beta1.MsgCreateValidator':
                return msgs_9.MsgCreateValidator.fromData(data);
            case '/cosmos.staking.v1beta1.MsgEditValidator':
                return msgs_9.MsgEditValidator.fromData(data);
            // wasm
            case '/terra.wasm.v1beta1.MsgStoreCode':
                return msgs_10.MsgStoreCode.fromData(data);
            case '/terra.wasm.v1beta1.MsgMigrateCode':
                return msgs_10.MsgMigrateCode.fromData(data);
            case '/terra.wasm.v1beta1.MsgInstantiateContract':
                return msgs_10.MsgInstantiateContract.fromData(data);
            case '/terra.wasm.v1beta1.MsgExecuteContract':
                return msgs_10.MsgExecuteContract.fromData(data);
            case '/terra.wasm.v1beta1.MsgMigrateContract':
                return msgs_10.MsgMigrateContract.fromData(data);
            case '/terra.wasm.v1beta1.MsgUpdateContractAdmin':
                return msgs_10.MsgUpdateContractAdmin.fromData(data);
            case '/terra.wasm.v1beta1.MsgClearContractAdmin':
                return msgs_10.MsgClearContractAdmin.fromData(data);
            // ibc-transfer
            case '/ibc.applications.transfer.v1.MsgTransfer':
                return msgs_11.MsgTransfer.fromData(data);
            // ibc-client
            case '/ibc.core.client.v1.MsgCreateClient':
                return client_1.MsgCreateClient.fromData(data);
            case '/ibc.core.client.v1.MsgUpdateClient':
                return client_1.MsgUpdateClient.fromData(data);
            case '/ibc.core.client.v1.MsgUpgradeClient':
                return client_1.MsgUpgradeClient.fromData(data);
            case '/ibc.core.client.v1.MsgSubmitMisbehaviour':
                return client_1.MsgSubmitMisbehaviour.fromData(data);
            // ibc-connection
            case '/ibc.core.connection.v1.MsgConnectionOpenInit':
                return connection_1.MsgConnectionOpenInit.fromData(data);
            case '/ibc.core.connection.v1.MsgConnectionOpenTry':
                return connection_1.MsgConnectionOpenTry.fromData(data);
            case '/ibc.core.connection.v1.MsgConnectionOpenConfirm':
                return connection_1.MsgConnectionOpenConfirm.fromData(data);
            case '/ibc.core.connection.v1.MsgConnectionOpenAck':
                return connection_1.MsgConnectionOpenAck.fromData(data);
            // ibc-channel
            case '/ibc.core.channel.v1.MsgChannelOpenInit':
                return channel_1.MsgChannelOpenInit.fromData(data);
            case '/ibc.core.channel.v1.MsgChannelOpenTry':
                return channel_1.MsgChannelOpenTry.fromData(data);
            case '/ibc.core.channel.v1.MsgChannelOpenConfirm':
                return channel_1.MsgChannelOpenConfirm.fromData(data);
            case '/ibc.core.channel.v1.MsgChannelOpenAck':
                return channel_1.MsgChannelOpenAck.fromData(data);
            case '/ibc.core.channel.v1.MsgChannelCloseInit':
                return channel_1.MsgChannelCloseInit.fromData(data);
            case '/ibc.core.channel.v1.MsgChannelCloseConfirm':
                return channel_1.MsgChannelCloseConfirm.fromData(data);
            case '/ibc.core.channel.v1.MsgRecvPacket':
                return channel_1.MsgRecvPacket.fromData(data);
            case '/ibc.core.channel.v1.MsgAcknowledgement':
                return channel_1.MsgAcknowledgement.fromData(data);
            case '/ibc.core.channel.v1.MsgTimeout':
                return channel_1.MsgTimeout.fromData(data);
            case '/ibc.core.channel.v1.MsgTimeoutOnClose':
                return channel_1.MsgTimeoutOnClose.fromData(data);
            // crisis
            case '/cosmos.crisis.v1beta1.MsgVerifyInvariant':
                return crisis_1.MsgVerifyInvariant.fromData(data);
        }
    }
    Msg.fromData = fromData;
    function fromProto(proto) {
        switch (proto.typeUrl) {
            // bank
            case '/cosmos.bank.v1beta1.MsgSend':
                return msgs_1.MsgSend.unpackAny(proto);
            case '/cosmos.bank.v1beta1.MsgMultiSend':
                return msgs_1.MsgMultiSend.unpackAny(proto);
            // distribution
            case '/cosmos.distribution.v1beta1.MsgSetWithdrawAddress':
                return msgs_2.MsgSetWithdrawAddress.unpackAny(proto);
            case '/cosmos.distribution.v1beta1.MsgWithdrawDelegatorReward':
                return msgs_2.MsgWithdrawDelegatorReward.unpackAny(proto);
            case '/cosmos.distribution.v1beta1.MsgWithdrawValidatorCommission':
                return msgs_2.MsgWithdrawValidatorCommission.unpackAny(proto);
            case '/cosmos.distribution.v1beta1.MsgFundCommunityPool':
                return msgs_2.MsgFundCommunityPool.unpackAny(proto);
            // feegrant
            case '/cosmos.feegrant.v1beta1.MsgGrantAllowance':
                return msgs_3.MsgGrantAllowance.unpackAny(proto);
            case '/cosmos.feegrant.v1beta1.MsgRevokeAllowance':
                return msgs_3.MsgRevokeAllowance.unpackAny(proto);
            // gov
            case '/cosmos.gov.v1beta1.MsgDeposit':
                return msgs_4.MsgDeposit.unpackAny(proto);
            case '/cosmos.gov.v1beta1.MsgSubmitProposal':
                return msgs_4.MsgSubmitProposal.unpackAny(proto);
            case '/cosmos.gov.v1beta1.MsgVote':
                return msgs_4.MsgVote.unpackAny(proto);
            // market
            case '/terra.market.v1beta1.MsgSwap':
                return msgs_5.MsgSwap.unpackAny(proto);
            case '/terra.market.v1beta1.MsgSwapSend':
                return msgs_5.MsgSwapSend.unpackAny(proto);
            // authz
            case '/cosmos.authz.v1beta1.MsgGrant':
                return msgs_6.MsgGrantAuthorization.unpackAny(proto);
            case '/cosmos.authz.v1beta1.MsgRevoke':
                return msgs_6.MsgRevokeAuthorization.unpackAny(proto);
            case '/cosmos.authz.v1beta1.MsgExec':
                return msgs_6.MsgExecAuthorized.unpackAny(proto);
            // oracle
            case '/terra.oracle.v1beta1.MsgDelegateFeedConsent':
                return msgs_7.MsgDelegateFeedConsent.unpackAny(proto);
            case '/terra.oracle.v1beta1.MsgAggregateExchangeRatePrevote':
                return msgs_7.MsgAggregateExchangeRatePrevote.unpackAny(proto);
            case '/terra.oracle.v1beta1.MsgAggregateExchangeRateVote':
                return msgs_7.MsgAggregateExchangeRateVote.unpackAny(proto);
            // slashing
            case '/cosmos.slashing.v1beta1.MsgUnjail':
                return msgs_8.MsgUnjail.unpackAny(proto);
            // staking
            case '/cosmos.staking.v1beta1.MsgDelegate':
                return msgs_9.MsgDelegate.unpackAny(proto);
            case '/cosmos.staking.v1beta1.MsgUndelegate':
                return msgs_9.MsgUndelegate.unpackAny(proto);
            case '/cosmos.staking.v1beta1.MsgBeginRedelegate':
                return msgs_9.MsgBeginRedelegate.unpackAny(proto);
            case '/cosmos.staking.v1beta1.MsgCreateValidator':
                return msgs_9.MsgCreateValidator.unpackAny(proto);
            case '/cosmos.staking.v1beta1.MsgEditValidator':
                return msgs_9.MsgEditValidator.unpackAny(proto);
            // wasm
            case '/terra.wasm.v1beta1.MsgStoreCode':
                return msgs_10.MsgStoreCode.unpackAny(proto);
            case '/terra.wasm.v1beta1.MsgMigrateCode':
                return msgs_10.MsgMigrateCode.unpackAny(proto);
            case '/terra.wasm.v1beta1.MsgInstantiateContract':
                return msgs_10.MsgInstantiateContract.unpackAny(proto);
            case '/terra.wasm.v1beta1.MsgExecuteContract':
                return msgs_10.MsgExecuteContract.unpackAny(proto);
            case '/terra.wasm.v1beta1.MsgMigrateContract':
                return msgs_10.MsgMigrateContract.unpackAny(proto);
            case '/terra.wasm.v1beta1.MsgUpdateContractAdmin':
                return msgs_10.MsgUpdateContractAdmin.unpackAny(proto);
            case '/terra.wasm.v1beta1.MsgClearContractAdmin':
                return msgs_10.MsgClearContractAdmin.unpackAny(proto);
            // ibc-transfer
            case '/ibc.applications.transfer.v1.MsgTransfer':
                return msgs_11.MsgTransfer.unpackAny(proto);
            // ibc-client
            case '/ibc.core.client.v1.MsgCreateClient':
                return client_1.MsgCreateClient.unpackAny(proto);
            case '/ibc.core.client.v1.MsgUpdateClient':
                return client_1.MsgUpdateClient.unpackAny(proto);
            case '/ibc.core.client.v1.MsgUpgradeClient':
                return client_1.MsgUpgradeClient.unpackAny(proto);
            case '/ibc.core.client.v1.MsgSubmitMisbehaviour':
                return client_1.MsgSubmitMisbehaviour.unpackAny(proto);
            // ibc-connection
            case '/ibc.core.connection.v1.MsgConnectionOpenInit':
                return connection_1.MsgConnectionOpenInit.unpackAny(proto);
            case '/ibc.core.connection.v1.MsgConnectionOpenTry':
                return connection_1.MsgConnectionOpenTry.unpackAny(proto);
            case '/ibc.core.connection.v1.MsgConnectionOpenConfirm':
                return connection_1.MsgConnectionOpenConfirm.unpackAny(proto);
            case '/ibc.core.connection.v1.MsgConnectionOpenAck':
                return connection_1.MsgConnectionOpenAck.unpackAny(proto);
            // ibc-channel
            case '/ibc.core.channel.v1.MsgChannelOpenInit':
                return channel_1.MsgChannelOpenInit.unpackAny(proto);
            case '/ibc.core.channel.v1.MsgChannelOpenTry':
                return channel_1.MsgChannelOpenTry.unpackAny(proto);
            case '/ibc.core.channel.v1.MsgChannelOpenConfirm':
                return channel_1.MsgChannelOpenConfirm.unpackAny(proto);
            case '/ibc.core.channel.v1.MsgChannelOpenAck':
                return channel_1.MsgChannelOpenAck.unpackAny(proto);
            case '/ibc.core.channel.v1.MsgChannelCloseInit':
                return channel_1.MsgChannelCloseInit.unpackAny(proto);
            case '/ibc.core.channel.v1.MsgChannelCloseConfirm':
                return channel_1.MsgChannelCloseConfirm.unpackAny(proto);
            case '/ibc.core.channel.v1.MsgRecvPacket':
                return channel_1.MsgRecvPacket.unpackAny(proto);
            case '/ibc.core.channel.v1.MsgAcknowledgement':
                return channel_1.MsgAcknowledgement.unpackAny(proto);
            case '/ibc.core.channel.v1.MsgTimeout':
                return channel_1.MsgTimeout.unpackAny(proto);
            case '/ibc.core.channel.v1.MsgTimeoutOnClose':
                return channel_1.MsgTimeoutOnClose.unpackAny(proto);
            // crisis
            case '/cosmos.crisis.v1beta1.MsgVerifyInvariant':
                return crisis_1.MsgVerifyInvariant.unpackAny(proto);
            default:
                throw Error("not supported msg ".concat(proto.typeUrl));
        }
    }
    Msg.fromProto = fromProto;
})(Msg = exports.Msg || (exports.Msg = {}));
//# sourceMappingURL=Msg.js.map